import type { BoardAgentContextValue } from "./hooks/board-agent-context";

type BoardAgentListener = (value: BoardAgentContextValue | null) => void;

let registered: BoardAgentContextValue | null = null;
const listeners = new Set<BoardAgentListener>();

function notify() {
	for (const listener of listeners) {
		listener(registered);
	}
}

export function registerBoardAgent(value: BoardAgentContextValue) {
	registered = value;
	notify();

	return () => {
		if (registered === value) {
			registered = null;
			notify();
		}
	};
}

export function getBoardAgent() {
	return registered;
}

export function subscribeBoardAgent(listener: BoardAgentListener) {
	listeners.add(listener);
	listener(registered);

	return () => {
		listeners.delete(listener);
	};
}

export function resetBoardAgentRegistryForTests() {
	registered = null;
	listeners.clear();
}
